import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Link} from "react-router-dom";
import axios from "axios";
import * as XLSX from 'xlsx';
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import Select from 'react-select';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import * as moment from "moment";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class AdminUploadProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productData: [],    ///to store product data
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: false,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            party_options: [
                { value: 'Brand', label: 'Brand' },
                { value: 'Merchant', label: 'Merchant' },
            ],
            party_list: [],
            party_list1: [],
            selected_party_type: null,
            selected_party: null,
            selected_party_type2: null,
            selected_party2: null,
            upload_user_type: null,
            party_master_id: null,
            party_master_id_copy: 3,
            partyTypeID: '',
            partyTypeValue: null,
            partyID: '',
            partyValue: null,
            partyValueNull: [{value: null, label: null}],
            newOrgModel: false,
            all_skus:'',
            
            bulkDropdown: false,
            bulkSelectedFile: null,
            bulkFileName: '',
            isBulkSubmitting: false,
            bulkLoading: false,
            bulkNotify: 0,
            bulkInconsistent: 0,
            bulkError2: 0,
            bulkTotal: 0,
            bulkTotalValue: 0,
            bulkFileId: null,
            bulkReportFileName: '',
            bulkReportDownloadName: '',
            bulkFlag: null,
            bulkErrorMessage: '',
            bulkErrorHeader: '',
            bulkSkuColumn:     "",   // user picks which CSV column is SKU
            bulkPrice:         "",   // user picks price column
            bulkDescription:   "",   // description column
            bulkTotalRows:     0,
            bulkSavedRows:     0,
            bulkFailedRows:    0,
            bulkFailedRecords: [],  // array of strings
            bulkResultMessage: "",
            canBulkUpdate: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.toggleBulkDropdown    = this.toggleBulkDropdown.bind(this);
        this.onBulkChangeHandler   = this.onBulkChangeHandler.bind(this);
        this.bulkFileUploadHandler = this.bulkFileUploadHandler.bind(this);
        this.fileInputRef = React.createRef();
        this.bulkFileInputRef = React.createRef();
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        const canUpdate = this.canBulkUpdate();
        console.log("Can bulk update:", canUpdate);
        this.setState({
            canBulkUpdate: canUpdate
        });
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        this.getPartyID();
        this.getPartyList();
        //var _notificationSystem = this.refs.notificationSystem;
        this.getBrandUploadedData1();
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        if (decoded.userGroup == '7' || decoded.userGroup == 7){
            this.setState({
                selected_party_type: 'Brand'
            })
        }
        else if (decoded.userGroup == '2' || decoded.userGroup == 2){
            this.setState({
                selected_party_type: 'Merchant'
            })
        }
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
                this.setState({
                    party_master_id: 3,
                    loading: false,
                    user_id: decoded._id
                //}, () => {
                   // this.getBrandUploadedData();
                });
            }
            else{
                 //console.log(response.data);
                var party_master_id_var = "";
                response.data.map((values, index) => {
                    //console.log(values.party_id);
                    party_master_id_var = values.party_id
//                     this.setState({
//                         party_master_id: values.party_id,
//                         party_master_id_copy: 3,
//                         upload_user_type: decoded.userGroup
//                     })
                })
                this.setState({
                    party_id_mapper: response.data,
                    party_master_id: party_master_id_var,
                    party_master_id_copy:3,
                    upload_user_type:decoded.userGroup
                });
                $('#party_showTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
                //this.getBrandUploadedData();
            }
        });
    }

    showUnauthorizedPopup = (actionName) => {
        this.handleNotificationClick("tr", 3, `You are not authorized to perform "${actionName}". Please contact your administrator.`);
    }


    getPartyList() {
        const token = localStorage.usertoken;
        axios.get(config.get('API_URL')+'/brandemi/findAllManufacturers',
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {  console.log(response);
            let party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                if (values.party_name != 'Admin'){
                    party_list.push({value: values.id, label: values.party_name})
                }
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }

    getPartyList1 = () => {
        const token = localStorage.usertoken;
        axios.get(config.get('API_URL')+'/brandemi/findAllManufacturers', 
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { //console.log(response);
            let party_list1 = [];
            this.setState({
                party_list1: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                party_list1.push({value: values.id, label: values.party_name})
            });
            this.setState({
                party_list1: party_list1,
                loading: false
            })
        });
    }

    updatePartyType2 = (valuer) => {
        let upload_user_type = 2;
        if (valuer.value == 'Merchant'){
            upload_user_type = 2;
        }
        else if( valuer.value == 'Brand'){
            upload_user_type = 7;
        }
        this.setState({
            selected_party_type: valuer.value,
            selected_party_type2: [{value: valuer.value, label: valuer.label}],
            upload_user_type: upload_user_type,
            loading: true,
            selected_party: null,
            selected_party2: null,
            party_master_id: 3,
            party_list1: []
        }, () => {
            this.getPartyList1();
        });
    };
    canBulkUpdate = () => {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log("Decoded user ID:", decoded._id);

        // List of user IDs who can stop promotions
        const allowedUsers = process.env.REACT_APP_ALLOWED_USER;
        console.log("Allowed users:", allowedUsers);

        return allowedUsers.includes(decoded._id);
    }

    updatePartyValue2 = (valuer) => {
        this.setState({
            selected_party: valuer.value,
            selected_party2: [{value: valuer.value, label: valuer.label}],
            party_master_id: valuer.value
        });

    };

    updatePartyType(optionSelected){
//         this.setState({
//             loading: true
//         })
        let value='';
        let partyTypeArray = [];
        if(optionSelected.length<1){
            value = null;
            partyTypeArray = '';
        }
        else{
            optionSelected.map((partytypeids, i) => {
                partyTypeArray.push(partytypeids.value)
            });
        }
        this.setState({
            partyTypeID:partyTypeArray,
            partyTypeValue:optionSelected,
            // partyID: '',
            // partyValue: this.state.partyValueNull,
            party_list: []
        }, () =>{
            this.getPartyList();
            this.getBrandUploadedData1();
        });

        // this.setState({
        //     selected_party_type: valuer.value,
        //     selected_party_type2: [{value: valuer.value, label: valuer.label}],

        //     upload_user_type: 7,

        //     selected_party: null,
        //     selected_party2: null,
        //     party_master_id: 5,
        //     party_list: []
        // }, () => {
        //     this.getPartyList();
        // });

    };

    updatePartyValue(optionSelected){
//         this.setState({
//             loading: true
//         })
        let value='';
        let partyArray = [];
        if(optionSelected.length<1){
            value = null;
            partyArray = '';
        }
        else{
            optionSelected.map((partyids, i) => {
                partyArray.push(partyids.value)
            });
        }
        this.setState({
            partyID:partyArray,
            partyValue:optionSelected,
            loading: false
        }, () => {
            this.getBrandUploadedData1();
        });

        // this.setState({
        //     selected_party: valuer.value,
        //     selected_party2: [{value: valuer.value, label: valuer.label}],
        //     party_master_id: valuer.value,
        //     loading: false,
        //     uploadDropdown: false
        // }, () => {
        //     this.getBrandUploadedData();
        // });
    };


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        if(this.state.selected_party_type == null){
            this.handleNotificationClick("tr", 3, "Please select a party type first");
        }
        else{
            this.setState({
                open_instructions: !this.state.open_instructions
            });
        }
    }

    onChangeHandler = event => {
        if (event.target.files.length == 0){
            this.handleNotificationClick("tr", 3, "Please select a file");
        }
        else{
            var file = event.target.files[0];
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                this.setState({
                    selectedFile: file,
                    file_name: file.name
                });
            } else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    selectedFile: file
                });
            }
        }
        
    };

    onBulkChangeHandler(e) {
        const file = e.target.files[0];
        if (!file) {
            this.handleNotificationClick("tr", 3, "Please select a file");
            return;
        }
        const ext = this.getFileExtension(file.name);
        if (ext !== 'xlsx') {
            this.handleNotificationClick("tr", 3, "Please upload a valid XLSX");
            return;
        }
        this.setState({ bulkSelectedFile: file, bulkFileName: file.name });
    }

    handleChange(checked) {
        //console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }
    getBrandUploadedData1() {
        const canBulkUpdate = this.state.canBulkUpdate;
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().clear().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var postData = {
            party_type: this.state.partyTypeID,
            party_id: this.state.partyID
        };
        var DccSalesReports = $('#brandViewTable').DataTable(
            {
                order:[],
                // "dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 10,
                //"sPaginationType": "numbers",
                "bInfo": true,
                "responsive": false,
                "scrollX": false,
                "lengthMenu": [[10, 20, 50, 100, 500 -1], [10, 20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/brandemi/get_brand_data_filter_new",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        //isApiResponse(true);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {

                    },
                },

                columns: [
                        { "data": "party_type", "title": "Party Type" },
                        { "data": "party_name", "title": "Party Name" },
                        { "data": "file_name", "title": "File Name" },
                        { "data": "record_update_timestamp", "title": "Upload Time" },
                        { "data": "sku", "title": "SKU" },
                        { "data": "id", "title": "Action" }
                   ],
                   columnDefs: [
                   {  render: function (data) {
                            return '<td >'+moment(data).format('YYYY-MM-DD H:mm:ss')+'</td>';
                        },
                        "width": "150px",
                        "targets": 3
                    },
                    {
                        "width": "200px",
                        "targets": 4,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');

                            if(rowData.sku==null || rowData.sku=='null' || rowData.sku=='') {
                                $(td).text('');

                            }
                            else {
                                var n = rowData.sku.split(",").length;
                                if (n > 1) {
                                    var trimmedString = rowData.sku.split(",")[0];
                                    $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View All..</a>');
                                    $(td).click(e => {
                                        this.toggleNewOrgModel(e, rowData.sku);
                                    })
                                } else {
                                    $(td).append(rowData.sku );
                                }
                            }
                        },
                        bSortable: false,
                    },
                    {

                        "className":"text-center",
                        "targets": 5,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                                $(td).append('<a href="#" data-tip="Download" title="Download" id="Download" class="viewButton"><span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a> ');
                                $(td).append('<a href="#" data-tip="Stop" title="View" id="View" class="viewButton"><span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span></a>');
                                $(td).find('#View').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.redirect_to_product_details(e, rowData.id, rowData.sku);
                                });
                                $(td).find('#Download').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    //this.downloadCSV(e, rowData.id, rowData.file_name);
                                    this.downloadProductDataCSV(e, rowData.id, rowData.file_name); //  updated method
                                });
                        },
                        bSortable: false,
                    },
                ]
            });
    }
    getBrandUploadedData(){
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().clear().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/get_brand_data_filter', {
            party_type: this.state.partyTypeID,
            party_id: this.state.partyID
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response);
            let activer_var = {}
            response.data.data.map((value, index) => {
                let status = false;
                if(value.active_status===1) { status = true;}
                activer_var[index] = status;
//                 this.setState({
//                     activer: {...this.state.activer, [index]:status }
//                 });
            });
            this.setState({
                brand_file_uploaded: response.data.data,
                loading: false,
                activer:activer_var
            });
            $('#brandViewTable').DataTable({
                "data": response.data.data,
                "columns": [
                        { "data": "party_type", "title": "Party Type" },
                        { "data": "party_name", "title": "Party Name" },
                        { "data": "file_name", "title": "File Name" },
                        { "data": "record_update_timestamp", "title": "Upload Time" },
                        { "data": "brand_sku_codes", "title": "SKU" },
                        { "data": "id", "title": "Action" }
                   ],
                   columnDefs: [
                    {

                        "className":"text-center",
                        "targets": 4,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');

                            if(rowData.brand_sku_codes==null || rowData.brand_sku_codes=='null' || rowData.brand_sku_codes=='') {
                                $(td).text('');

                            }
                            else {
                                var n = rowData.brand_sku_codes.split(",").length;
                                if (n > 1) {
                                    var trimmedString = rowData.brand_sku_codes.split(",")[0];
                                    $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View All..</a>');
                                    $(td).click(e => {
                                        this.toggleNewOrgModel(e, rowData.brand_sku_codes);
                                    })
                                } else {
                                    $(td).append(rowData.brand_sku_codes );

                                }
                            }
                        },
                        bSortable: false,
                    },
                    {

                        "className":"text-center",
                        "targets": 5,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                                $(td).append('<a href="#" data-tip="Stop" title="View" id="View" class=""><i class="fa fa-eye" aria-hidden="true"></i></a>');
                                $(td).append('<a href="#" data-tip="Download" title="Download" id="Download" class=""><span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>');
                                $(td).find('#View').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.redirect_to_product_details(e, rowData.id, rowData.sku);
                                });
                                $(td).find('#Download').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.downloadCSV(e, rowData.id, rowData.file_name);
                                });
                        },
                        bSortable: false,
                    },
                ]

            });
        });
        return null;
    }
    redirect_to_product_details(e, id, sku) {
       const { history } = this.props;
       localStorage.setItem('skuData', sku);
        history.push(`/admin/new-brand-viewer?id=${id}`);

    }
    toggleNewOrgModel(e, issue) {
        this.setState({
            newOrgModel: !this.state.newOrgModel,
            all_skus: issue
        })
    }
    
        downloadCSV(e, file_id, file_value) {
            if (file_id === 'none.csv') {
                this.handleNotificationClick("tr", 3, "Please select a party type first");
                return;
            }

            this.setState({ is_download: false });
    //         alert(file_id)
    //         alert(file_value)
    //         alert(e)
            const url = `${config.get('API_URL')}/brandemi/download_csv?file_id=${encodeURIComponent(file_id)}`;

            $.ajax({
                url,
                method: 'GET',
                beforeSend: xhr => {
                xhr.setRequestHeader("Authorization", localStorage.usertoken);
                },
                // **** Override the XHR to ensure we get a real Blob ****
                xhr: () => {
                const xhr = new window.XMLHttpRequest();
                xhr.responseType = 'blob';
                return xhr;
                },
                success: (blob, status, xhr) => {
                // mime‐type from server is probably application/octet-stream or text/csv
                // you can override it here if you like:
                const downloadBlob = new Blob([blob], { type: blob.type || 'text/csv' });
                let fileName = file_value;
                // special cases:
                if (e === '7xhmd38Hhdad3_brand_product_master_template.csv' || e==='none.csv') {
                    fileName = 'products-template.csv';
                } else if (file_id === '34ksf39jfsf_merchant_product_master_template.csv') {
                    fileName = 'merchant-products-template.csv';
                }
                // strip any quotes:
                fileName = fileName.replace(/"/g, '');

                // Create a hidden link, click it programmatically:
                const a = document.createElement('a');
                a.style.display = 'none';
                document.body.appendChild(a);

                const objectUrl = window.URL.createObjectURL(downloadBlob);
                a.href = objectUrl;
                a.download = fileName;
                a.click();

                window.URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);

                this.setState({ is_download: true });
                this.setState({ xhr: xhr});
                },
                error: (xhr, status, err) => {
                console.error("Download failed:", status, err);
                this.handleNotificationClick("tr", 3, "Failed to download file");
                this.setState({ is_download: true });
                }
            });
        }

//         exportProductDataAsCSV = () => {
//     const { productData } = this.state;
//
//     if (!productData || productData.length === 0) {
//         this.handleNotificationClick("tr", 2, "No product data to export.");
//         return;
//     }
//
//     const csvRows = [];
//     const headers = Object.keys(productData[0]);
//     csvRows.push(headers.join(','));
//
//     for (const row of productData) {
//         const values = headers.map(header => `"${(row[header] ?? "").toString().replace(/"/g, '""')}"`);
//         csvRows.push(values.join(','));
//     }
//
//     const csvContent = csvRows.join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);
//
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'product_data.csv');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
// };
    downloadProductDataCSV = (e, fileId, fileName) => {
      const sku = localStorage.getItem('skuData') || '';
    axios.get(config.get('API_URL') + '/brandemi/view_brand_sku_id_new',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: fileId,
                sku: sku
            }
        }).then(response => {
        const data = response.data.data;
        if (!data || data.length === 0) {
            this.handleNotificationClick("tr", 2, "No product data to export.");
            return;
        }

        const headers = Object.keys(data[0]);
        const csvRows = [
            headers.join(','),
            ...data.map(row =>
                headers.map(field =>
                    `"${(row[field] ?? '').toString().replace(/"/g, '""')}"`
                ).join(',')
            )
        ];

        const csvContent = csvRows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || 'product_data.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }).catch(err => {
        console.error("Error fetching product data:", err);
        this.handleNotificationClick("tr", 3, "Failed to fetch product data");
    });
};

    bulkMopMrpUpload(e, file_id, file_value) {
        if (file_id === 'none.csv') {
            this.handleNotificationClick("tr", 3, "Please select a party type first");
            return;
        }

        this.setState({ is_download: false });
//         alert(file_id)
//         alert(file_value)
//         alert(e)
        const url = `${config.get('API_URL')}/brandemi/download_csv1?file_id=${encodeURIComponent(file_id)}`;

        $.ajax({
            url,
            method: 'GET',
            beforeSend: xhr => {
            xhr.setRequestHeader("Authorization", localStorage.usertoken);
            },
            // **** Override the XHR to ensure we get a real Blob ****
            xhr: () => {
            const xhr = new window.XMLHttpRequest();
            xhr.responseType = 'blob';
            return xhr;
            },
            success: (blob, status, xhr) => {
            // mime‐type from server is probably application/octet-stream or text/csv
            // you can override it here if you like:
            const downloadBlob = new Blob([blob], { type: blob.type || 'text/csv' });
            let fileName = file_value;
            // special cases:
            if (e === '7xhmd38Hhdad3_brand_product_master_template.csv' || e==='none.csv') {
                fileName = 'bulkMopMrpUpload.csv';
            } else if (file_id === '34ksf39jfsf_merchant_product_master_template.csv') {
                fileName = 'merchant-bulkMopMrpUpload.csv';
            }
            // strip any quotes:
            fileName = fileName.replace(/"/g, '');

            // Create a hidden link, click it programmatically:
            const a = document.createElement('a');
            a.style.display = 'none';
            document.body.appendChild(a);

            const objectUrl = window.URL.createObjectURL(downloadBlob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();

            window.URL.revokeObjectURL(objectUrl);
            document.body.removeChild(a);

            this.setState({ is_download: true });
            this.setState({ xhr: xhr});
            },
            error: (xhr, status, err) => {
            console.error("Download failed:", status, err);
            this.handleNotificationClick("tr", 3, "Failed to download file");
            this.setState({ is_download: true });
            }
        });
    }


    downloadReportCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value;
                //console.log(file_value);
                //console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    fileUploadHandler = () => {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const timer1 = (Date.now()).toString();
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true
        });
        if ((decoded.userGroup == 1 || decoded.userGroup == '1') && (this.state.selected_party == null || this.state.selected_party_type == null)){
            this.handleNotificationClick("tr", 3, "Please select a party");
            this.setState({
                loading: false,
                isSubmit: false
            })
        }
        else{
            
            const data = new FormData();
            data.append('file', this.state.selectedFile);
            data.append('userID', decoded._id);
            data.append('timer', this.state.timer);
            data.append('timer1', timer1);
            // let random_string = Date.now()+'_'+req.body.userID+'_';
            //console.log(decoded.userGroup);
            data.append('userGroup', decoded.userGroup);
            data.append('upload_user_type', this.state.upload_user_type);
            data.append('party_master_id', this.state.party_master_id);
            if(this.state.selectedFile == null){
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
            else{
                var file = this.state.selectedFile; //console.log(data);
                var ext = this.getFileExtension(file.name);
                if (ext === 'csv') {
                    axios.post(config.get('API_URL') + "/brandemi/new_upload", data, {
                        headers: {
                            Authorization: ` ${localStorage.usertoken}`
                        }
                    })
                    .then(res => {
                        console.log(res.data);
                        this.setState({
                            file_id_got: res.data.fileId,
                            report_file_name: res.data.reportFileName
                        });
                        //console.log(res.data.notify);
                        //console.log(res.data.inconsistent);
                        if (res.data.flag == -1){
                            this.handleNotificationClick("tr", 3, "Something Wrong");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                report_download_name: res.data.reportDownloadName,
                                error_message: '0' + '/' + '0',
                                error_message_header: 'Failure'
                            });
                        }
                        else if (res.data.flag == 2){
                            this.handleNotificationClick("tr", 2, "File with same name uploaded. Please change file name and continue.");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                report_download_name: res.data.reportDownloadName,
                                error_message_header: 'Duplicate File',
                                error_message: '0' + '/' + '0'
                            });
                        }
                        else if(res.data.flag == 3){
                            this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                report_download_name: res.data.reportDownloadName,
                                error_message: res.data.totalValue + '/' + res.data.total,
                                error_message_header: 'Failure'
                            });
                            
                        }
                        else if(res.data.flag == 4){
                            this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                report_download_name: res.data.reportDownloadName,
                                error_message: res.data.totalValue + '/' + res.data.total,
                                error_message_header: 'Failure'
                            });
                        }
                        else if (res.data.flag == 5){
                            this.handleNotificationClick("tr", 3, "File is not in csv utf-8 format.");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                report_download_name: res.data.reportDownloadName,
                                error_message: '0' + '/' + '0',
                                error_message_header: 'Format Issue'
                            });
                        }
                        else if (res.data.flag == 6){
                            this.handleNotificationClick("tr", 3, "No data present in uploaded csv");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                report_download_name: res.data.reportDownloadName,
                                error_message_header: 'Empty Template',
                                error_message: '0' + '/' + '0'
                            });
                        }
                        else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
                            if (this.fileInputRef.current) {
                                this.fileInputRef.current.value = '';
                            }
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                error_message: res.data.totalValue + '/' + res.data.total,
                                error_message_header: 'Success',
                                selectedFile: null,
                                file_name: ''
                            });
                            //alert("hi")
                            //console.log("call show method on success");
                            this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                            this.toggleNoErrorModel.bind(this);
                            this.getBrandUploadedData();
                        } 
                        
                        else {
                            if (res.data.error2 === 1){
                                this.setState({
                                    error_message_header: 'Failure'
                                })
                                this.getBrandUploadedData();
                            }
                            else{
                                this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                                this.toggleNoErrorModel.bind(this);
                                this.setState({
                                    error_message_header: 'Success',
                                     selectedFile: '',
                                     file_name: ''
                                })
                                this.getBrandUploadedData();
                            }
                            if (this.fileInputRef.current) {
                                this.fileInputRef.current.value = '';
                            }
                            this.setState({
                                isSubmit: false,
                                error_message: res.data.totalValue + '/' + res.data.total,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.fileId,
                                report_file_name: res.data.reportFileName,
                                selectedFile: '',
                                file_name: ''
                            });
                        }
                    })
                    .catch(err => { 
                        console.log(err);// then print response status
                        this.handleNotificationClick("tr", 3, "Something Wrong!");
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });
                        // this.openSectionToMap(true); // remove and place in success block
                    })
                }
                else {
                    this.handleNotificationClick("tr", 3, "Please upload valid file");
                    this.setState({
                        isSubmit: false,
                        loading: false
                    });
                }
            }
        }
    };

    downloadFailedSKUs = () => {
        const { bulkFailedRecords } = this.state;
        if (!bulkFailedRecords || bulkFailedRecords.length === 0) return;

        // Convert array to CSV string
        const csvContent = "data:text/csv;charset=utf-8," 
       + bulkFailedRecords.join("\n");

        // Encode URI
        const encodedUri = encodeURI(csvContent);

        // Create temporary link and click it
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "failed_skus.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    async bulkFileUploadHandler() {
        const token   = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const timer1  = Date.now().toString();

        if (!this.state.canBulkUpdate) {
            this.showUnauthorizedPopup("Bulk Update");
            return;
        }

        if (!this.state.bulkSelectedFile) {
            this.handleNotificationClick("tr", 3, "Please select a file");
            return;
        }

         // Excel file validation
       const validTypes = [
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
       ];

        const fileName = this.state.bulkSelectedFile.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
         if (
        !["xls", "xlsx"].includes(fileExtension) ||
        !validTypes.includes(this.state.bulkSelectedFile.type)
        ) {
        this.handleNotificationClick("tr", 3, "File format is incorrect. Please upload an Excel file (.xls or .xlsx).");
        return;
       }

         // Read Excel and check headers before proceeding
        const file = this.state.bulkSelectedFile;
        const dataBuffer = await file.arrayBuffer();
        const workbook = XLSX.read(dataBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // raw array rows
        const headers = jsonData[0]?.map(h => h?.toString().trim().toLowerCase());

        const requiredHeaders = ["mop", "mrp", "sku"];
        const hasAllHeaders = requiredHeaders.every(col => headers.includes(col));

        if (!hasAllHeaders) {
        this.handleNotificationClick("tr", 3, "File contains invalid data. Missing one or more of: mop, mrp, sku.");
        return;
       }

        const data = new FormData();
        data.append('file', this.state.bulkSelectedFile);
        data.append('userID', decoded._id);
        data.append('userGroup', decoded.userGroup);

        this.setState({ isBulkSubmitting: true, bulkLoading: true });

        axios.post(
            config.get('API_URL') + "/brandemi/bulk_update",
            data,
            { headers: { Authorization: `${localStorage.usertoken}` } }
        )
        .then(res => {
            const d = res.data;
            this.setState({
                isBulkSubmitting: false,
                bulkLoading: false,
                bulkSavedRows: d.updatedRows,
                bulkFailedRows: d.failedRows,
                bulkTotalRows: d.totalRows,
                bulkResultMessage: d.status,
                bulkSelectedFile:null,
                bulkFailedRecords:d.failedSkus,
                // bulkNotify: d.notify,
                // bulkInconsistent: d.inconsistent,
                // bulkError2: d.error2,
                // bulkTotal: d.total,
                // bulkTotalValue: d.total_value,
                // bulkFileId: d.file_id,
                // bulkReportFileName: d.report_file_name,
                // bulkReportDownloadName: d.report_download_name,
                // bulkFlag: d.flag,
                // bulkErrorHeader: this.flagToMessage(d.flag),
                // bulkErrorMessage: `${d.total_value}/${d.total}`
            });

            if (this.bulkFileInputRef.current) {
                this.bulkFileInputRef.current.value = '';
            }
            this.handleNotificationClick(
            "tr",
            d.status === "COMPLETED" ? 1 : 3,
            "Bulk Update completion " + d.status
            );
        })
        .catch(err => {
            console.error(err);
            this.handleNotificationClick("tr", 3, "Something went wrong");
            this.setState({ isBulkSubmitting: false, bulkLoading: false });
        });
    }

    // helper to map flag → friendly header
    flagToMessage(flag) {
        switch(flag) {
            case 2: return "Duplicate File";
            case 3: return "No valid data";
            case 4: return "Invalid columns";
            case 5: return "Not UTF-8 CSV";
            case 6: return "Empty CSV";
            default: return flag === 0 ? "Success" : "Failure";
        }
    }

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    activeHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        if(this.state.activer.length == 0 || this.state.activer.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.activer));
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        axios.post(config.get('API_URL') + "/brandemi/active_updater", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                //console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    this.props.history.push('/admin/admin-upload-products')
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })

        }
        
    };
    
    changeStatus(index, stored_file_name, user_id, checked) {
        //let status = 0;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer: {...this.state.activer, [index]:checked }
        })
    }

    // uploadDropdownHandler = () => {
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     if (this.state.partyValue != null){
    //         if(this.state.partyValue.length > 1){
    //             this.handleNotificationClick("tr", 3, "Select only one party");
    //         }
    //         else if(this.state.partyValue.length == 1){
    //             let checker = this.state.partyValue;
    //             if (checker[0].value1 == 'Merchant'){
    //                 this.state.partyValue.map((valuer, index) => {
    //                     this.setState({
    //                         party_master_id: valuer.value,
    //                         upload_user_type: 2,
    //                         selected_party_type: 'Merchant'
    //                     })
    //                 })
    //                 this.setState({
    //                     uploadDropdown: true
    //                 })    
    //             }
    //             else{
    //                 this.state.partyValue.map((valuer, index) => {
    //                     this.setState({
    //                         party_master_id: valuer.value,
    //                         upload_user_type: 7,
    //                         selected_party_type: 'Brand'
    //                     })
    //                 })
    //                 this.setState({
    //                     uploadDropdown: true
    //                 })
    //             } 
    //         }
    //     }
    //     else{
    //         this.handleNotificationClick("tr", 3, "Select atleast one party");
    //     }   
    // }

    uploadDropdownHandler = () => {
        if (!this.state.canBulkUpdate) {
            this.showUnauthorizedPopup("Import Products");
            return;
        }
        this.setState({
            uploadDropdown: true,
            bulkDropdown:false
        })  
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    downloadReport(){
        //console.log(this.state.report_file_name);
        this.downloadReportCSV.bind(this, 1, this.state.report_file_name);
    }



    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    gotoUploadedFile(){
        let pusher = '/admin/new-brand-viewer/' + this.state.file_id_got
        this.props.history.push(pusher)
    }

    toggleBulkDropdown() {
        if (!this.state.canBulkUpdate) {
            this.showUnauthorizedPopup("Bulk Update");
            return;
        }
        this.setState(({ bulkDropdown }) => ({ bulkDropdown: !bulkDropdown }));
        this.setState({
            uploadDropdown: false
        })
    }


    render() {
        const { canBulkUpdate } = this.state;
        let to_display_party = "Select party";
        if(this.state.selected_party_type == "Brand"){
            to_display_party = "Select brand"; 
        }
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };


        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        //console.log(this.state.selected_party_type);
        //console.log(this.state.selected_party);
        //console.log(this.state.party_master_id);
        
        let brand_file_data = this.state.brand_file_uploaded.map((value, index) =>{
            //console.log(this.state.activer);
            let timer2 = new Date(value.record_update_timestamp)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            //let timer3 = timer2.getDay() + "-" + timer2.getMonth() + "-" + timer2.getFullYear() + " " + timer2.getHours() + ":" + timer2.getMinutes();
            return (
                <tr key={index + 1}>
                <td>{value.party_type}</td>
                <td>{value.party_name}</td>
{/*                 <td>{value.sku}</td> */}
                <td>{value.file_name}</td>
                <td>{timer3}</td>
                {/* <td>
                    {console.log(this.state.activer[index])}
                    {console.log(value.active_status)}
                <Switch className="react-switch" height={20} width={38} id={value.stored_file_name} onChange={this.changeStatus.bind(this, index, value.stored_file_name, value.user_id)} checked={(this.state.activer[index])? true : false}></Switch>
                </td> */}
                <td>

                    <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                    <Link className="viewButton" data-tip="Download File" onClick={this.downloadCSV.bind(this, value.id, value.file_name)}><span className="glyphicon glyphicon-download-alt" aria-hidden="true"></span></Link>
                    &nbsp;
                    <Link className="viewButton" data-tip="View"  to={"/admin/new-brand-viewer/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                </td>
            </tr>
            )
        });

        

        let dropdowner = () =>{
            if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="row">
                        <div className="col-md-3">
                            <Label>Select party type</Label>
                            <ReactMultiSelectCheckboxes name={"party_type_filter"}
                                components={{ MenuList }}
                                value={this.state.partyTypeValue}
                                styles={customStyles} className="report-listbox"
                                onChange={this.updatePartyType.bind(this)}
                                options={party_render}
                                placeholderButtonLabel="Select [Party Type]"
                                // isClearable={true}
                                
                            />
                        </div>  
                        <div className="col-md-3">
                            <Label>Select party</Label>
                            <ReactMultiSelectCheckboxes name={"party_name_filter"}
                                components={{ MenuList }}
                                value={this.state.partyValue}
                                styles={customStyles} className="report-listbox"
                                onChange={this.updatePartyValue.bind(this)}
                                options={this.state.party_list}
                                placeholderButtonLabel="Select [Party Name]"
                                // isClearable={true}
                            />
                        </div> 
                    </div>
                )
            }
                else{
                    return(
                        <div></div>
                    )
                }
        }

        let error_message = this.state.error_message;
        let error_message_headere = () => {
            let value_header = this.state.error_message_header;
            if(value_header == 'Failure'){
                return(
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="redtexter">{value_header}</div>
                        </div>    
                    </div>
                );
            }
            else if(value_header == 'Success'){
                return(
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="greentexter">{value_header}</div>
                        </div>    
                    </div>
                );
            }
        }
        
        let link_to_show = () => {
            if (this.state.error_message_header == 'Success'){
                return(
                    <a href="#" onClick={this.gotoUploadedFile.bind(this)}>View</a>
                );
            }
            else if (this.state.error_message_header == 'Failure'){
                return(
                    <a href="#" onClick={this.downloadReportCSV.bind(this, 1, this.state.report_file_name, this.state.report_download_name)}>View report</a>
                )
            }
            else{
                return(
                    <div></div>
                )
                
            }
            
        }

        let party_render = this.state.party_options;
        let party_render_list = this.state.party_list;
        let party_render_list1 = this.state.party_list1;
        let download_texter = '';
        if (this.state.selected_party_type == 'Brand'){
            download_texter = '7xhmd38Hhdad3_brand_product_master_template.csv';
        }
        else if(this.state.selected_party_type == 'Merchant'){
            download_texter = '34ksf39jfsf_merchant_product_master_template.csv';
        }
        else{
            download_texter = 'none.csv';
        }
        
        let instructionser = () => {
            if(this.state.selected_party_type == 'Brand'){
                return(
                    <div className="row">
                        <div className="col-md-12">
                            - Keep .csv encoding in UTF-8 format<br/>
                            - Mandatory fields are brand, category, model_number, model_name, model_description, sku, mop and mrp<br/>
                            - sku and model_description should be unique<br/>
                            - Avoid using special characters<br/>
                        </div>
                    </div>
                )
            }
            else if (this.state.selected_party_type == 'Merchant'){
                return(
                    <div className="row">
                        <div className="col-md-12">
                            - Keep .csv encoding in UTF-8 format<br/>
                            - Mandatory fields are brand, category, level_1, level_2, sku, mrp and brand_sku<br/>
                            - Keep image url in level_4 (example: https://images-na.ssl-images-amazon.com/images/I/51o5RmQtroL._SL1024_.jpg)
                        </div>
                    </div>
                )
            }
        }

        return (
            <div className="longcontent">
                <CommonNavbar/>
            <div className="container-fluid">
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <Modal className="modalsmall" isOpen={this.state.open_instructions} 
                    toggle={this.openInstructions.bind(this)} 
                    size="lg"
                    >
                    <ModalHeader>Instructions</ModalHeader>
                    <ModalBody>
                        {instructionser()}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" className="btn-capitalize" onClick={this.openInstructions.bind(this)}>Close</Button>
                    </ModalFooter>
                </Modal>   
                <div className="pt-5" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            <h4 className="title pull-left">Products</h4>
                            {/*//download products*/}
                            {/*<Button color="success" onClick={this.exportProductDataAsCSV} className="btn-capitalize pull-right" style={{ marginRight: "10px" }}>*/}
                            {/*  Export Product Data*/}
                            {/*</Button>*/}
                            {/* {canBulkUpdate && ( */}
                                <button onClick={this.uploadDropdownHandler} className="btn btn-primary btn-capitalize pull-right">Import</button>,
                                <button onClick={this.toggleBulkDropdown} className="btn btn-primary btn-capitalize pull-right">Bulk Update</button>
                            {/* )} */}
                        </div>
                        <div className="clearfix"></div>
                        <div className="content">
                            {dropdowner()}
                            <div className="row">
                                <div className="container-fluid">
                                    <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">    
                                        <table className="table table-striped table-hover" id="brandViewTable">
                                            <thead>
                                                <tr>
                                                    <th>Party Type</th>
                                                    <th>Party Name</th>
{/*                                                     <th>SKU</th> */}
                                                    <th>File Name</th>
                                                    <th>Upload Time</th>
                                                    <th>SKU</th>
                                                    {/* <th>Active</th> */}
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
{/*                                                 {brand_file_data} */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className ="col-md-12">
                                    {/* <button onClick={this.activeHandler} className="btn btn-primary btn-capitalize pull-right">Update</button> */}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Collapse isOpen={this.state.bulkDropdown}>
                    <div className="col-md-4">
                        <div className="card pm-height">
                        <div className="header">
                            <h4 className="title">Step 1: Download Format</h4>
                        </div>
                        <hr/>
                        <div className="row top-margin-5">
                            <div className="col-md-12 pull-centere">
                                <Button color="primary" className="btn-capitalize pull-centere" name="download" onClick={this.bulkMopMrpUpload.bind(this, download_texter, 1)}>Download Template</Button>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="card pm-height">
                        <div className="header">
                            <h4 className="title">Step 2: Upload Excel</h4>
                        </div>
                        <hr/>
                        <div className="form-group">
                            <input
                            type="file"
                            accept=".xlsx"
                            className="form-control"
                            onChange={this.onBulkChangeHandler}
                            ref={this.bulkFileInputRef}
                            />
                        </div>
                        <Button
                            color="primary"
                            className="btn-capitalize"
                            disabled={this.state.isBulkSubmitting}
                            onClick={this.bulkFileUploadHandler}>
                            { this.state.bulkLoading ? "Uploading…" : "Upload File" }
                        </Button>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 3: Results</h4>
                            </div>
                            <hr/>
                            <div className="content">
                                <p>{this.state.bulkResultMessage}</p>
                                <p>
                                Success: {this.state.bulkSavedRows} / {this.state.bulkTotalRows}<br/>
                                Failures: {this.state.bulkFailedRows}
                                </p>
                            </div>
                        </div>
                    </div>
                    {this.state.bulkFailedRows > 0 && (
                        <div style={{ marginTop: "10px" }}>
                            <button 
                                onClick={this.downloadFailedSKUs}
                                style={{
                                    padding: "6px 12px",
                                    background: "#dc3545",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer"
                                }} >
                               Download Failed SKUs
                            </button>
                        </div>
                    )}

                </Collapse>
                
                <Collapse isOpen={this.state.uploadDropdown}>
                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 1: Download Template</h4>
                            </div>
                            <hr/>
                            {/* <div className="content"> */}
                                <div className="row">
                                    <div className="col-md-6 product-master-padding-right">
                                        <Label>Select party type</Label>
                                        <Select name={"party_type"}
                                            value={this.state.selected_party_type2}
                                            onChange={this.updatePartyType2.bind(this)}
                                            options={party_render}
                                            placeholder="Select party type"
                                            className="product-master-select"
                                            // isClearable={true}
                                        />
                                    </div>  
                                    <div className="col-md-6 product-master-padding-left">
                                        <Label>{to_display_party}</Label>
                                        <Select name={"party_name"}
                                            value={this.state.selected_party2}
                                            onChange={this.updatePartyValue2.bind(this)}
                                            options={party_render_list1}
                                            placeholder="Select party"
                                            className="product-master-select"
                                            // isClearable={true}
                                        />
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <label htmlFor="sampleName">Upload Instructions</label>
                                </div>
                                 <div className="row">
                                    <Card className="noshadow">
                                        <CardBody>
                                        <CardText className="cardtexter">
                                        - Keep .csv encoding in UTF-8 format<br/>
                                        - Mandatory fields are brand, category, level_1, level_2, sku and mrp<br/>
                                        - Keep image url in level_4 (example: https://images-na.ssl-images-amazon.com/images/I/51o5RmQtroL._SL1024_.jpg)
                                        </CardText>
                                        </CardBody>
                                    </Card>  
                                </div> */}
                                <div className="row top-margin-5">
                                    <div className="col-md-12 pull-centere">
                                        <Button color="primary" className="btn-capitalize pull-centere" name="download" onClick={this.downloadCSV.bind(this, download_texter, 1)}>Download Template</Button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 pull-centere">
                                        <a href="#" className="pull-center" onClick={this.openInstructions.bind(this)}>View Instructions</a>
                                    </div>
                                </div>
                                <div className="row">
                                    <br/>
                                </div>
                                <div className="row">
                                    <br/>
                                </div>
                            {/* </div> */}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 2: Upload Template</h4>
                            </div>
                            <hr/>
                            
                                <form method="post" action="#" id="#">
                                    
                                        <div className="col-md-12 pull-centere">
                                            <div className="form-group bottom-margin-0">
                                                <label htmlFor="queryName" className="pull-centere">Upload</label>
                                                <input type="file" name="file" className="form-control pull-centere" onChange={this.onChangeHandler}
                                                 ref={this.fileInputRef}
                                                 key={this.state.fileInputKey || 'fileInput'}
                                                />
                                            </div>
                                            <div className="row top-pad-0">
                                                <div className="col-md-12">
                                                    <button type="button" className="btn btn-primary btn-capitalize" onClick={this.fileUploadHandler} disabled={this.state.isSubmit}>Upload File</button>
                                                </div>
                                            </div>
                                        </div>
                                    
                                </form>
                            
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 3: Results</h4>
                            </div>
                            <hr/>
                            <div className="content">
                                {error_message_headere()}
                                <div className="row">
                                    <div className="col-md-12">
                                        {error_message}
                                    </div>  
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {link_to_show()}
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
            </div>
            <Modal isOpen={this.state.newOrgModel} toggle={this.toggleNewOrgModel.bind(this)} >
                <ModalHeader toggle={this.toggleNewOrgModel.bind(this)}>SKUs</ModalHeader>
                <ModalBody>
                    <div className="issue_container">
                        {this.state.all_skus}
                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button color="secondary" onClick={this.toggleNewOrgModel.bind(this)}>Cancel</Button>
                </ModalFooter>
            </Modal>
            </div>
        );
    }
}
export default AdminUploadProducts;